<template>
<CRow>
  <CCol col="12" xl="12">
    <CCard>
      <CCardHeader>
        <CCol col="6" style="font-size: 25px;">عرض الطالب</CCol>
      </CCardHeader>
      <CCardBody>
        <div class="row">
            <div class="col-md-6">
              <img :src="student.image_full_path?student.image_full_path:
              'https://i1.wp.com/researchictafrica.net/wp/wp-content/uploads/2016/10/default-profile-pic.jpg?ssl=1'" width="150" height="150" >
                <table class="table table-bordered">
                  <tr>
                    <th>رقم الطالب</th>
                    <td>{{ student.id }}</td>
                  </tr>
                  <tr>
                    <th>الإسم الأول</th>
                    <td>{{ student.first_name }}</td>
                  </tr>
                  <tr>
                    <th> الإسم الأخير</th>
                    <td>{{ student.last_name }}</td>
                  </tr>
                  <tr>
                    <th>رقم الهاتف</th>
                    <td>{{ student.mobile }}</td>
                  </tr>
                  <tr>
                    <th>البريد الإلكتروني</th>
                    <td>{{ student.email }}</td>
                  </tr>
                </table>
            </div>
        </div>
        <CButton color="warning" @click="goBack">رجوع</CButton>
      </CCardBody>
    </CCard>
  </CCol>
</CRow>
</template>

<script>
export default {
  name: 'ShowCategory',
  data () {
    return {
      student: []
    }
  },
  created () {
    console.log(this.$route.params.id)
    this.$http
      .get(`${this.$hostUrl}students/${this.$route.params.id}/edit`)
      .then((response) => {
        this.student = response.data.data.student
      })
  },
  methods: {
    goBack () {
      this.studentsOpened ? this.$router.go(-1) : this.$router.push({ path: '/students' })
    }
  }
}
</script>
<style scoped>
  th {
    background-color: #3c4b64;
    color: #f5f3f3;
  }
  img{
    border-radius: 50%;
  margin: 10px 0;
  }
</style>
